import axios from 'axios'

export default () => {
  return axios.create({
    baseURL: process.env.API_URL,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js